module.exports = __webpack_public_path__ + "static/media/md-return-right.a4b78bd3.svg";